import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
// Import Views - Dash
// import DashboardView from './components/views/Dashboard.vue'
// import TablesView from './components/views/Tables.vue'
// import TasksView from './components/views/Tasks.vue'
// import AccessView from './components/views/Access.vue'
// import ServerView from './components/views/Server.vue'
// import ReposView from './components/views/Repos.vue'
// import ForecastView from './components/views/Forecast.vue'
// import JobdashboardView from './components/views/Dashboard.vue'
import VisnetworkView from './components/views/Report.vue'
import ModelHistory from './components/views/Model-history.vue'
// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'Dashboard',
        component: ModelHistory,
        name: 'dashboard',
        alias: '',
        meta: { description: 'Dashboard' }
      },
      {
        path: 'Report',
        component: VisnetworkView,
        name: 'VisnetworkView',
        alias: '',
        meta: { description: 'VisnetworkView' }
      }
    ]
  },
  {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js